import LZString from 'lz-string';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { isArray, isObject } from "util";
import SessionManager from "../../routes/SessionManager";
import DateUtil from "../../util/DateUtil";
import DownloadReport from "../common/DownloadReport";
import { Table } from "antd";
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

function HumanPowerReport(props) {
  var sessionMgr = new SessionManager();
  var user1 = sessionMgr.readCookie('user');

  const [loading, setLoading] = useState(false);
  const [person_info, setPersonInfo] = useState([]);
  const [user, setUser] = useState(user1);
  const [hpr_url, setHprUrl] = useState('');
  const [zones, setZones] = useState([]);

  let timezone = user.site_selected.site_iana_timezone;

  let report_columns = [
    {
      title: "Zone Name",
      dataIndex: 'location_name',
      key: 'location_name',
      render: (keep_it, w) => w.location_name,
      sorter: (a, b) => {
        var x = a['location_name'];
        var y = b['location_name'];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      },
      sortDirections: ["ascend", "descend", "ascend"]
    },
    {
      title: "Max. Person Count",
      dataIndex: 'keep_it',
      key: 'keep_it',
      render: (keep_it, w) => person_info[w.location_id] ? person_info[w.location_id].max_person_count : 0,
      sorter: (a, b) => {
        var x = person_info[a.location_id] ? person_info[a.location_id].max_person_count : 0;
        var y = person_info[b.location_id] ? person_info[b.location_id].max_person_count : 0;
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      },
      sortDirections: ["ascend", "descend", "ascend"]
    },
    {
      title: "First Appearance",
      dataIndex: 'keep_it',
      key: 'keep_it',
      render: (keep_it, w) => person_info[w.location_id] ? moment.tz(person_info[w.location_id].start_person_ts * 1000, timezone).format('YYYY-MM-DD HH:mm') : 0,
      sorter: (a, b) => {
        var x = person_info[a.location_id] ? person_info[a.location_id].start_person_ts : 0;
        var y = person_info[b.location_id] ? person_info[b.location_id].start_person_ts : 0;
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      },
      sortDirections: ["ascend", "descend", "ascend"]
    },
    {
      title: "Last Appearance",
      dataIndex: 'keep_it',
      key: 'keep_it',
      render: (keep_it, w) => person_info[w.location_id] ? moment.tz(person_info[w.location_id].last_person_ts * 1000, timezone).format('YYYY-MM-DD HH:mm') : 0,
      sorter: (a, b) => {
        var x = person_info[a.location_id] ? person_info[a.location_id].last_person_ts : 0;
        var y = person_info[b.location_id] ? person_info[b.location_id].last_person_ts : 0;
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      },
      sortDirections: ["ascend", "descend", "ascend"]
    },
  ];

  useEffect(() => {
    setUser(user);
    if (!timezone)
      timezone = moment.tz.guess();
    setLoading(true);

    if (user.site_selected) {
      let allowedFields = ['location_config', 'enabled', 'feature_controls', 'motion_detection', 'customer_id', 'zones', 'site_selected', 'site_name', 'site_iana_timezone', 'site_id', 'user_login', 'user_token', 'location_id', 'location_name', 'site_config'];
      let minifiedUser = preparePdfData(user, allowedFields);
      minifiedUser.date = props.pickedDate ? props.pickedDate : moment().format("YYYY-MM-DD");
      minifiedUser.is_today = minifiedUser.date && minifiedUser.date === moment().format("YYYY-MM-DD");

      let site_info = user.site_selected.site_name + "_" + Buffer.from(user.user_login).toString('base64') + '_' + minifiedUser.date;
      minifiedUser.save_report = true;
      minifiedUser.request_id = 'Man Power Report - ' + site_info + '.pdf';
      //console.log('HPR ' + JSON.stringify(minifiedData, null, 4));

      setHprUrl(API.getFullUrl('/pdf/man-power-report/Man Power Report - ' + site_info + '.pdf?' + LZString.compressToBase64(JSON.stringify(minifiedUser)) + '=payload'));
      fetchHumanPowerReport();

    }
  }, [])

  const preparePdfData = (obj, allowedFields) => {
    var data = { ...obj };
    for (var i in data) {
      if (allowedFields.indexOf(i) !== -1) {
        if (data[i] && isArray(data[i])) {
          for (var y in data[i]) {
            for (var z in data[i][y]) {
              if (allowedFields.indexOf(z) === -1) {
                delete data[i][y][z];
              } else {
                if (data[i][y][z] && isObject(data[i][y][z])) {
                  for (var m in data[i][y][z]) {
                    if (allowedFields.indexOf(m) === -1) {
                      delete data[i][y][z][m];
                    } else {
                      if (data[i][y][z][m] && isObject(data[i][y][z][m])) {
                        for (var c in data[i][y][z][m]) {
                          if (allowedFields.indexOf(c) === -1) {
                            delete data[i][y][z][m][c];
                          } else {
                            if (data[i][y][z][m][c] && isObject(data[i][y][z][m][c])) {
                              for (var n in data[i][y][z][m][c]) {
                                if (allowedFields.indexOf(n) === -1) {
                                  delete data[i][y][z][m][c][n];
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        } else if (data[i] && isObject(data[i])) {
          for (var x in data[i]) {
            if (allowedFields.indexOf(x) === -1) {
              delete data[i][x];
            }
          }
        } else {
          if (allowedFields.indexOf(i) === -1) {
            delete data[i];
          }
        }
      } else {
        delete data[i];
      }
    }

    if (!data.site_selected.site_config || !data.site_selected.site_config.work_hours || !data.site_selected.site_config.work_hours.work_hours_start
      || !data.site_selected.site_config.work_hours.work_hours_end) {
      data.site_selected.site_config.work_hours = DateUtil.getConfiguredWorkHours(user).work_hours;
    }
    return data;
  }

  const fetchHumanPowerReport = () => {

    var data = {
      report_type: 'daily_report',
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      date: props.pickedDate ? props.pickedDate : moment().format("YYYY-MM-DD"),
      timezone: timezone
    }

    let { work_hours_start, work_hours_end } = DateUtil.getConfiguredWorkHours(user.site_selected).work_hours;
    data = { ...data, work_hours_start, work_hours_end: work_hours_end.replace(":00", ":59") }

    CommonUtils.ajax(
      {
        url: API.REPORTS.STANDARD_DAILY,
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data)
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          var person_info = res.data.person_info;
          setZones(user.zones);
          setPersonInfo(person_info);
          setLoading(false);
        }
      },
      (res) => {

      });
  }

  return (
    <React.Fragment>
      <div className="modal-header p-2 bg-primary text-white">
        <span className="modal-title">{props.title}</span>
        <div>
          <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
          <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
        </div>
      </div>
      {!loading &&
        <div className="modal-footer bg-light" style={{ padding: '0.5rem 1rem' }}>
          <DownloadReport report_url={hpr_url}></DownloadReport>
          <label className="font-weight-bold text-primary" style={{ position: "absolute", left: "1rem" }}>{user && user.site_selected && user.site_selected.site_name}</label>
        </div>
      }
      <div className="modal-body py-4">
        <Table
          loading={loading}
          rowKey="location_id"
          dataSource={zones.filter((z) => ((z.location_config === undefined || z.location_config.feature_controls === undefined || z.location_config.feature_controls.motion_detection === undefined) || (z.location_config && z.location_config.feature_controls && z.location_config.feature_controls.motion_detection && z.location_config.feature_controls.motion_detection.enabled))) || []}
          columns={report_columns}
          pagination={false}
        />
      </div>
    </React.Fragment>
  );
}

export default HumanPowerReport;